<template>
  <v-card class="cardBg" flat outlined width="600px">
    <v-form ref="form">
      <v-card-title class="text-h5 deep-purple darken-4 white--text">
        Change Password
      </v-card-title>
      <v-container fluid>
        <v-row>
          <v-col>
            <v-card-text>
              <div class="grey--text">
                This will change your sign in password. Please enter your old
                password in the top section and new password in the bottom
                section. If you forgot your password, log out and click forgot
                password.
              </div>
            </v-card-text>
            <v-text-field
              single-line
              v-model="oldPassword"
              prepend-icon="mdi-lock"
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.required, rules.min]"
              :type="show ? 'text' : 'password'"
              name="input-10-1"
              color="blue"
              label="Old Password"
              placeholder="Old Password..."
              hint="At least 8 characters"
              counter
              @click:append="show = !show"
              class="px-12"
              id="old-password"
            >
            </v-text-field>
            <v-text-field
              single-line
              v-model="newPassword"
              prepend-icon="mdi-lock"
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.required, rules.min]"
              :type="show ? 'text' : 'password'"
              name="input-10-1"
              color="blue"
              label="New Password"
              placeholder="New Password..."
              hint="At least 8 characters"
              counter
              @click:append="show = !show"
              class="px-12"
              id="new-password"
            >
            </v-text-field>
            <v-text-field
              single-line
              v-model="passwordMatch"
              prepend-icon="mdi-lock"
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.required, rules.min, passwordConfirmationRule]"
              :type="show ? 'text' : 'password'"
              name="input-10-2"
              color="blue"
              label="Confirm Password"
              placeholder="Password..."
              hint="At least 8 characters"
              counter
              @click:append="show = !show"
              class="px-12"
              id="sign-up-password-confirm"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row justify="end" class="mt-9 mb-2">
          <v-col class="text-right">
            <v-btn
              style="text-transform: none"
              class="mr-2"
              color="error"
              @click="handleClose()"
            >
              Cancel</v-btn
            >
            <v-btn
              style="text-transform: none"
              color="primary"
              @click="updatePassword()"
              :disabled="isSaveDisabled"
            >
              Save
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </v-card>
</template>
<script>
import { Auth } from 'aws-amplify'
import { mapGetters } from 'vuex'

export default {
  name: 'PasswordUpdate',
  components: {},
  data() {
    return {
      oldPassword: '',
      newPassword: '',
      passwordMatch: '',
      show: false,
      rules: {
        required: (value) => !!value || 'Required',
        min: (v) => v?.length >= 8 || 'Min 8 characters',
      },
    }
  },
  computed: {
    ...mapGetters({
      currentUserProfile: 'getcurrentlySelectedAccountInformationArray',
      groups: 'getUserGroups',
    }),
    passwordConfirmationRule() {
      return () =>
        this.newPassword === this.passwordMatch || 'Password must match'
    },
    isSaveDisabled() {
      return (
        !this.newPassword ||
        !this.passwordMatch ||
        this.newPassword !== this.passwordMatch ||
        this.newPassword.length < 8
      )
    },
  },
  watch: {},
  methods: {
    async updatePassword() {
      Auth.currentAuthenticatedUser()
        .then((user) => {
          return Auth.changePassword(user, this.oldPassword, this.newPassword)
        })
        .then((data) => {
          const result = data
          if (result == 'SUCCESS') {
            this.$refs.form.reset()
            this.$emit('close')
            this.$store.commit(
              'setNotification',
              'Your password has been successfully changed!'
            )
          } else {
            this.$store.commit(
              'setNotification',
              'There was an issue resetting your password, you can try again. Make sure the code matches the one in your email and that your new password is different from your old one.'
            )
          }
        })
        .catch((err) => {
          console.log(err)
          this.$store.commit(
            'setNotification',
            'There was an issue resetting your password, you can try again. Make sure the code matches the one in your email and that your new password is different from your old one.'
          )
        })
    },
    handleClose() {
      console.log('close')
      this.$emit('close')
    },
  },
}
</script>
